<template>
    <div class="footContentBox">
        <!-- 上面 -->
        <div class="footBoxTop">
           <img src="static/image/footer.png" alt="">
        </div>

        <!-- 下面 -->
        <div class="footBoxBottom">
             <div class="footBottomContent col-8">
                 <div class="wrop">
                     <div class="listBox">
                        <h5 class="listTitle">新手指南</h5>
                        <ul class="listContentBox">
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;购物说明</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;购物保障</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;交易规则</router-link>
                            </li>     
                        </ul>
                    </div>
                 
                    <div class="listBox">
                        <h5 class="listTitle">支付方式</h5>
                        <ul class="listContentBox">
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;货到付款</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;在线支付</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;其他支付方式</router-link>
                            </li>     
                        </ul>
                    </div>

                    <div class="listBox">
                        <h5 class="listTitle">配送说明</h5>
                        <ul class="listContentBox">
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;配送运费</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;配送时间</router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="listBox">
                        <h5 class="listTitle">售后服务</h5>
                        <ul class="listContentBox">
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;退换货政策</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;退换货办理流程</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;退换货网上办理</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;退款说明</router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="listBox">
                        <h5 class="listTitle">关于我们</h5>
                        <ul class="listContentBox">
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;公司简介</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;合作专区</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;联系我们</router-link>
                            </li>
                            <li class="listContent">
                                <router-link to="" class="listContentLink">&gt;友情链接</router-link>
                            </li>
                        </ul>
                    </div>
                 </div>
             </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="less" scoped>
a{
    text-decoration: none;
    color: #000000;
}
li{
    list-style: none;
}
.footContentBox{
    width: 100%;
    margin-top: 10%;
    // 上面
    .footBoxTop{
        width: 100%;
        
        img{
            width: 100%;
        }
    }
    // 下面
    .footBoxBottom{
        width: 100%;
        height: 200px;
        background-color: #1a1a1a;
        margin-top: -3px;
        .footBottomContent{
            float: none;
            margin: 0 auto;
            box-sizing: border-box;
            .wrop{
                width: 100%;
                overflow: hidden;
                 .listBox{
                    float: left;
                    width: 20%;
                    padding: 0 0 0 8%;
                    box-sizing: border-box;
                    .listTitle{
                        line-height: 0;
                        color: #ababab;
                    }
                    .listContentBox{
                        padding-left: 0; 
                        .listContent{
                            float: none;
                            margin: 3px 0;
                            .listContentLink{
                                font-size: 12px;
                                color: #838383;
                            }
                        }
                    }
                }
                .listBox:nth-child(3){
                    padding-left: 9.5%;
                }
                .listBox:nth-child(4){
                    padding-left: 10%;
                }
                .listBox:last-child{
                    padding-left: 10.6%;
                }
            }
           
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer/index.vue